import {Injectable} from "@angular/core";
import {WebDataConnection} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";
import {ApiService} from "@app/_services/api.service";

@Injectable({
    providedIn: "root"
})
export class WebDataConnectionService extends TableOptionsService<WebDataConnection> {
    constructor(public apiService: ApiService) {
        super();
    }

    public override matches(element: WebDataConnection, term: string) {
        return (
            element.name?.toLowerCase().includes(term.toLowerCase()) ||
            element.description?.toLowerCase().includes(term.toLowerCase())
        );
    }
}
